import { useState } from 'react';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import { Button } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import './Accordion.scss';

const Accordion = ({ children, title }) => {
  const [showDetail, setShowDetail] = useState(true);

  return (
    <div>
      <section className="Content-groups-details mb-2">
        <div>
          <span className="style-title">{title}</span>
        </div>
        <Button
          className="styles-buttonKeyBoard"
          colorIcon="primary"
          icon={showDetail ? MdKeyboardArrowUp : MdKeyboardArrowDown}
          onClick={() => setShowDetail(!showDetail)}
          sizeIcon="30px"
          type="button"
          variant="light-gray"
          widthButton="40px"
        />
      </section>
      <div className="line-division" />
      {showDetail && <div>{children}</div>}
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired
};

export default Accordion;
